import { render, staticRenderFns } from "./universities.vue?vue&type=template&id=514ef864&scoped=true"
import script from "./universities.vue?vue&type=script&lang=js"
export * from "./universities.vue?vue&type=script&lang=js"
import style0 from "./universities.vue?vue&type=style&index=0&id=514ef864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ef864",
  null
  
)

export default component.exports